import { writable } from 'svelte/store'
import { default_modifier } from './bindings';
const settings = writable({ modifier: default_modifier });
const segments = writable([]);
const undefined_segments = writable([]);
const sections = writable([]);
const spectrogram_settings = writable({});
const active_docid = writable(null);
const state = writable(null);
const mouse = writable(null);
const key = writable(null);
const speaker = writable(null);
export {
    settings,
    segments,
    undefined_segments,
    sections,
    spectrogram_settings,
    active_docid,
    state,
    mouse,
    key,
    speaker
}
